import debounce from "lodash/debounce";
import { Component, Vue } from "vue-property-decorator";
import Template from "./ListManagementFilters.template.vue";
@Component({
  mixins: [Template]
})
export class ListManagementFiltersComponent extends Vue {
  public loaded: boolean = true;
  public isActive = true;
  public isMissingDetails = false;
  protected dFilter = debounce(
    c =>
      c.$emit("filter", {
        active: c.isActive,
        details: c.isMissingDetails
      }),
    500
  );

  public toggleActive() {
    this.isActive = !this.isActive;
    this.filter();
  }

  public toggleMissingDetails() {
    this.isMissingDetails = !this.isMissingDetails;
    this.filter();
  }

  public filter() {
    this.dFilter(this);
  }
}
